<c-card>
    <c-card-header class="card-header" >
      <h4 class="card-header__heading">Average time at repairer (Last 30 days) </h4>
    </c-card-header>
    <c-card-body class="min-height--300">
        <div *ngIf="isLoading" style="display: flex; justify-content: center;">
            <c-spinner variant="grow" />
        </div>

        <table datatable class="table table-striped" *ngIf="vehicleRepairData.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th title="Total accumulated time in the repairer">Average Duration at Repairer</th>
                    <th style="text-align: right;">View</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let vehicle of vehicleRepairData">
                    <td>{{ vehicle.name }}</td>
                    <td>{{ vehicle.averageTimeSpent | secondToDaysHoursMinutes }}</td>
                    <td style="text-align: right;"> <a [routerLink]="'detail/'+ vehicle.id">View Details</a> </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="vehicleRepairData.length === 0 && !isLoading">
            <div><p>There is no data</p></div>
        </div>
    </c-card-body>
</c-card>
